import React, { useEffect } from 'react'
import { isNil, find, isEmpty } from 'lodash'

import useUserContext from '../../hooks/useUserContext'
import { getRequestHeader } from '../../utils/api'

import AdArea from '../../components/AdArea'
import CurationCarousel from '../../components/CurationCarousel'

import { adSpots } from '../../advertisement'

import { AdAreaHeight } from '../../constants/enums'
import { useCurationQuery, CurationType } from '../../types/generated'

export default function CurationContainer() {
  const { data, loading, refetch, called } = useCurationQuery({
    context: { headers: getRequestHeader({ isAuthRequest: true }) },
    variables: {
      type: CurationType.HOME,
    },
  })
  const { isAuthenticated } = useUserContext()
  const articleMidAdSpot = find(adSpots, { name: 'ODC_ARTICLE_MID' })!

  useEffect(() => {
    if (called) {
      refetch()
    }
  }, [isAuthenticated, called, refetch])

  if (loading) {
    // FIXME: Change skeleton
    return null
  }

  if (isNil(data)) {
    return null
  }

  const [firstCuration, ...curations] = data.curation.nodes.filter(node => !isEmpty(node.carousels))

  return (
    <div className="Curations">
      {firstCuration && (
        <CurationCarousel
          isLoading={loading}
          curation={firstCuration}
          linkQuerystring={`pos=curation_${firstCuration.slug}`}
        />
      )}
      <AdArea className="HomePage__middleAd" adSpotId={articleMidAdSpot.spotId} height={AdAreaHeight.ARTICLE_MID} />
      {curations.map(
        curation =>
          curation && (
            <CurationCarousel
              key={curation.slug}
              isLoading={loading}
              curation={curation}
              linkQuerystring={`pos=curation_${curation.slug}`}
            />
          )
      )}
    </div>
  )
}
